/**
 * Utility helper functions
 */

export const genId = () => Math.random().toString(36).slice(2, 10);

export const genCode = () => Math.random().toString(36).slice(2, 8).toUpperCase();

export const now = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

export const getCurrentDate = () => new Date().toISOString().split("T")[0];

/**
 * Email validation
 * @param {string} email
 * @returns {boolean}
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Password validation (minimum 6 characters)
 * @param {string} password
 * @returns {boolean}
 */
export const isValidPassword = (password) => password && password.length >= 6;

/**
 * Get user initials from name
 * @param {string} name
 * @returns {string}
 */
export const getInitials = (name) => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};
